export type TableSortOrder = 'asc' | 'desc';

const DATE_KEYS = new Set([
  'dueDate',
  'issueDate',
  'paymentDate',
  'receiptDate',
  'createdAt',
  'updatedAt',
  'HireDate'
]);

const NUMERIC_KEYS = new Set([
  'amountToPay',
  'amountPaid',
  'amountToReceive',
  'originalAmount',
  'remainingAmount',
  'daysOverdue',
  'installmentNumber',
  'totalInstallments',
  'Id',
  'id'
]);

function toTimestamp(value: unknown): number {
  if (value == null || value === '') return Number.NaN;
  const d = value instanceof Date ? value : new Date(String(value));
  const t = d.getTime();
  return Number.isNaN(t) ? Number.NaN : t;
}

function toNumber(value: unknown): number {
  if (value == null || value === '') return Number.NaN;
  const n = typeof value === 'number' ? value : Number(value);
  return Number.isNaN(n) ? Number.NaN : n;
}

function toSortString(value: unknown): string {
  if (value == null) return '';
  return String(value).trim().toLocaleLowerCase('pt-BR');
}

function compareNumbers(a: unknown, b: unknown): number {
  const na = toNumber(a);
  const nb = toNumber(b);
  if (Number.isNaN(na) && Number.isNaN(nb)) return 0;
  if (Number.isNaN(na)) return 1;
  if (Number.isNaN(nb)) return -1;
  return na - nb;
}

function compareDates(a: unknown, b: unknown): number {
  const ta = toTimestamp(a);
  const tb = toTimestamp(b);
  if (Number.isNaN(ta) && Number.isNaN(tb)) return 0;
  if (Number.isNaN(ta)) return 1;
  if (Number.isNaN(tb)) return -1;
  return ta - tb;
}

function compareStrings(a: unknown, b: unknown): number {
  const sa = toSortString(a);
  const sb = toSortString(b);
  return sa.localeCompare(sb, 'pt-BR', { sensitivity: 'base', numeric: true });
}

function compareSortValues(a: unknown, b: unknown, key: string): number {
  if (DATE_KEYS.has(key)) return compareDates(a, b);
  if (NUMERIC_KEYS.has(key)) return compareNumbers(a, b);
  return compareStrings(a, b);
}

/** Ordena linhas da tabela no front (mesmos labels das colunas do app-table). */
export function sortTableRows<T>(
  rows: T[],
  sortBy: string,
  sortOrder: TableSortOrder
): T[] {
  if (!rows?.length || !sortBy) return rows ?? [];
  const dir = sortOrder === 'asc' ? 1 : -1;
  return [...rows].sort((a, b) => {
    const av = (a as Record<string, unknown>)[sortBy];
    const bv = (b as Record<string, unknown>)[sortBy];
    return compareSortValues(av, bv, sortBy) * dir;
  });
}
